import {LngLatLike, Map} from 'mapbox-gl';
import MapImage from './MapImage';

export const DEFAULT_PADDING = 75;

// continental US according to https://en.wikipedia.org/wiki/List_of_extreme_points_of_the_United_States
export const CONTINENTAL_US_BOUNDS = {
  southWest: [-124.7844079, 24.7433195] as LngLatLike,
  northEast: [-66.9513812, 49.3457868] as LngLatLike,
};

export async function addImages(map: Map, images: MapImage[]) {
  const loadedImages = await Promise.all(
    images.map((image) => image.load(map))
  );

  loadedImages.forEach(({id, image}) => {
    if (!map.hasImage(id)) {
      map.addImage(id, image as Parameters<Map['addImage']>[1]);
    }
  });

  return images;
}

export function extractZoomLevelsAndRadii(map: Map, layerId: string) {
  const layer = map.getLayer(layerId);
  if (!layer) {
    console.error(`Layer '${layerId}' not found.`);
    return null;
  }

  const paint = map.getPaintProperty(layerId, 'circle-radius');
  if (!Array.isArray(paint) || paint[0] !== 'interpolate') {
    console.error(
      `Layer '${layerId}' does not use 'interpolate' for 'circle-radius'.`
    );
    return null;
  }

  const [, , input, ...stops] = paint;

  if (input[0] !== 'zoom') {
    console.error(`Expected zoom-based interpolation. Got:`, input);
    return null;
  }

  const zoomLevels = [];
  const radii = [];

  for (let i = 0; i < stops.length; i += 2) {
    zoomLevels.push(parseFloat(stops[i]));
    radii.push(parseFloat(stops[i + 1]));
  }

  return {zoomLevels, radii};
}

export function interpolateRadius(
  zoom: number,
  {zoomLevels, radii}: {zoomLevels: number[]; radii: number[]}
) {
  if (zoom <= zoomLevels[0]) return radii[0];
  if (zoom >= zoomLevels[zoomLevels.length - 1])
    return radii[zoomLevels.length - 1];

  // Linear interpolation
  const t = (zoom - zoomLevels[0]) / (zoomLevels[1] - zoomLevels[0]);
  return radii[0] + t * (radii[1] - radii[0]);
}
